import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

/**
 * @param {ReactNode} children - render edilecek component
 * @param {string[]} allowedRoles - yetkili roller
 */
function PrivateRoute({ children, allowedRoles }) {
  const { user } = useContext(AuthContext);

  // Kullanıcı yoksa login sayfasına yönlendir
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Rol yetkisi yoksa anasayfaya yönlendir
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default PrivateRoute;
